<template>
  <div class="bottom-nav-container">
    <div class="bottom-nav-item" @click="navigateTo('Home')">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" :fill="isActive('Home') ? '#4A00E0' : '#A0A0A0'"/>
      </svg>
      <span :class="{ active: isActive('Home') }">{{ t('home') }}</span>
    </div>

    <div class="bottom-nav-item" @click="navigateTo('GradesList')">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 11H9V5H4V11ZM4 19H9V13H4V19ZM10 11H15V5H10V11ZM10 19H15V13H10V19ZM16 5V11H21V5H16ZM16 19H21V13H16V19Z" :fill="isActive('GradesList') ? '#4A00E0' : '#A0A0A0'"/>
      </svg>
      <span :class="{ active: isActive('GradesList') }">{{ t('grades') }}</span>
    </div>

    <div class="bottom-nav-item" @click="navigateTo('Bookmarks')">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" :fill="isActive('Bookmarks') ? '#4A00E0' : '#A0A0A0'"/>
      </svg>
      <span :class="{ active: isActive('Bookmarks') }">{{ t('bookmarks') }}</span>
    </div>

    <div class="bottom-nav-item" @click="navigateTo('UserProfile')">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" :fill="isActive('UserProfile') ? '#4A00E0' : '#A0A0A0'"/>
      </svg>
      <span :class="{ active: isActive('UserProfile') }">{{ t('profile') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  methods: {
    navigateTo(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },
    isActive(routeName) {
      return this.$route.name === routeName
    }
  }
}
</script>

<style scoped>
.bottom-nav-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5.5rem;
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 1000;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
}

.bottom-nav-item span {
  font-size: 1rem;
  margin-top: 6px;
  color: #A0A0A0;
}

.bottom-nav-item span.active {
  color: #4A00E0;
  font-weight: bold;
}
</style>